/*
 * *
 *   ~  * Copyright (c) by INFODATA-GROUP. All rights reserved.
 *   ~  * No part of this publication may be reproduced, distributed,
 *   ~  * or transmitted in any form or by any means, including photocopying, recording,
 *   ~  * or other electronic or mechanical methods, without the prior written permission of the publisher,
 *   ~  * except in the case of brief quotations embodied in critical
 *   ~  * reviews and certain other noncommercial uses permitted by copyright law.
 *   ~  * AUTHOR : bs
 *   ~  * DATE : 15/05/2025 17:48
 *
 */

import { Component, effect, inject, input, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WidgetWrapperComponent } from '../widget-wrapper/widget-wrapper.component';
import { Widget } from '../../../engine/widget/widget';
import { AuthorizationService } from '@infodata-group/inf-commons';
import { TranslateModule } from '@ngx-translate/core';
import { ToolsActions } from '../../../engine/tools/tools-actions';

type Infos = {
  key: string;
  value: unknown;
};

@Component({
  selector: 'infl-widget-session',
  standalone: true,
  imports: [CommonModule, WidgetWrapperComponent, TranslateModule],
  templateUrl: './widget-session.component.html',
  styleUrl: './widget-session.component.scss',
})
export class WidgetSessionComponent {
  private readonly authorizationService = inject(AuthorizationService);

  protected user = signal('john.doe@gmail.com');
  protected infos = signal<Infos[]>([]);

  public widget = input.required<Widget>();
  public readonly actions = [ToolsActions.getCloseAction()];

  constructor() {
    effect(() => {
      if (this.authorizationService.user) {
        this.user.set(this.authorizationService.user.toString());
      }
      if (this.authorizationService.userContext) {
        this.infos.set(
          Object.keys(this.authorizationService.userContext).map((key) => {
            return {
              key,
              value: this.authorizationService.userContext[key],
            };
          }),
        );
      }
    });
  }
}
